var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMessageEdit = function SvgMessageEdit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M10.666 1.333H5.333q-4 0-4 4V14c0 .367.3.667.667.667h8.666q4 0 4-4V5.333q0-4-4-4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "m8.607 5.227-3.46 3.46c-.133.133-.26.393-.287.58l-.186 1.32c-.067.48.266.813.746.746l1.32-.186c.187-.027.447-.154.58-.287l3.46-3.46c.594-.593.88-1.287 0-2.167-.88-.886-1.573-.606-2.173-.006"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M8.113 5.72a3.13 3.13 0 0 0 2.167 2.167"
  })));
};
export default SvgMessageEdit;